import { CalendarToday, Person } from "@mui/icons-material"
import { Box, Divider, Stack, Typography } from "@mui/material"

export default function ByAtInfo({ at, name, title }) {
	if (!at) return null
	return (
		<Stack>
			<Divider />
			<Typography
				variant="h6"
				component="h3"
				gutterBottom
				fontWeight="600"
				color="text.primary"
			>
				{title}
			</Typography>
			<Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
					<Person fontSize="small" color="action" />
					<Typography variant="body2" color="text.secondary">
						{name}
					</Typography>
				</Box>
			</Box>
			<Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
					<CalendarToday fontSize="small" color="action" />
					<Typography variant="body2" color="text.secondary">
						{at}
					</Typography>
				</Box>
				<Typography variant="body1" fontWeight="medium"></Typography>
			</Box>
		</Stack>
	)
}
